/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const ticketResource = '/merchant/ticket'

const defaultPagination = 5

export default {
  getTicketTypes() {
    return OperationRepository.get(`${ticketResource}-types`)
  },
  getAllTickets(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${ticketResource}?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getAllTicketsNoPagination(filterQuery) {
    return Repository.get(`${ticketResource}?${filterQuery}&noPagination`)
  },
  getTicketById(id) {
    return OperationRepository.get(`${ticketResource}/${id}`)
  },
  getTicketConvos(id) {
    return Repository.get(`${ticketResource}/${id}/convos`)
  },
  createTicket(payload) {
    const formData = new FormData()
    for (const key in payload) {
      formData.append(key, payload[key])
    }
    return Repository.post(`${ticketResource}`, formData)
  },
  updateTicket(id, payload) {
    const formData = new FormData()
    for (const key in payload) {
      formData.append(key, payload[key])
    }
    return Repository.post(`${ticketResource}/${id}/convos`, formData)
  },
}
